export enum DeliveryTypes {
	NotificationPerRecord,
	SingleNotification,
}
